/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warning-icon': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24 0C10.74 0 0 10.74 0 24c0 13.254 10.74 24 24 24s23.998-10.746 23.998-24c0-13.26-10.737-24-23.997-24zm0 44.085c-11.093 0-20.085-8.99-20.085-20.086 0-11.097 8.992-20.09 20.086-20.09 11.093 0 20.087 8.995 20.087 20.092 0 11.093-8.994 20.084-20.087 20.084z" _fill="#FF4242" fill-opacity=".8"/><path pid="1" d="M26.552 29.192l.976-20.09h-7.01l.978 20.09h5.056zM24.022 31.403c-2.348 0-3.99 1.643-3.99 4.039 0 2.304 1.596 4.034 3.897 4.034h.093c2.394 0 3.946-1.73 3.946-4.034-.044-2.396-1.596-4.039-3.946-4.039z" _fill="#FF4242" fill-opacity=".8"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/warning-icon.js